import { Component, OnInit } from '@angular/core';
import { SearchablePaneComponent } from '../searchable-pane/searchable-pane.component';
import {
  AlternateNonUsf,
  NonUSFProductViewModel,
  NonUsfRadioItem,
} from '@inventory/pages/manage-non-usf-products/models/non-usf-products-view-model';
import { Product } from '@shared/models/product.model';

@Component({
  selector: 'app-multi-select-non-usf',
  templateUrl: './multi-select-non-usf.component.html',
  styleUrls: ['./multi-select-non-usf.component.scss'],
})
export class MultiSelectNonUsfComponent extends SearchablePaneComponent {
  constructor() {
    super();
  }

  nonUsfSelected(nonUsf: Product) {
    nonUsf.nonUSFData.selected = !nonUsf.nonUSFData.selected;
    this.right?.handleItemSelection(
      this.left,
      this.platform,
      this.right,
      nonUsf,
    );
    this.checkValidity.emit();
  }

  handleSelectAll = ($event, searchedItems: Product[]) => {
    const selected = $event?.detail?.checked;
    const unselectedItems = searchedItems.filter(
      nonUsf => !nonUsf.nonUSFData.selected === selected,
    );
    unselectedItems.forEach(nonUsf => {
      nonUsf.nonUSFData.selected = selected;
      this.right?.handleItemSelection(
        this.left,
        this.platform,
        this.right,
        nonUsf,
      );
    });
    this.checkValidity.emit();
  };
}
